export interface Store {
  id: string;
  name: string;
  code: string;
  region: string;
  isActive: boolean;
}

export const STORES: Store[] = [
  {
    id: 'oracle',
    name: 'Oracle',
    code: 'OR',
    region: 'Arizona',
    isActive: true
  },
  {
    id: 'tanque-verde',
    name: 'Tanque Verde',
    code: 'TV',
    region: 'Arizona',
    isActive: true
  },
  {
    id: 'tangerine',
    name: 'Tangerine',
    code: 'TG',
    region: 'Arizona',
    isActive: true
  },
  {
    id: 'speedway',
    name: 'Speedway',
    code: 'SW',
    region: 'Arizona',
    isActive: true
  },
  {
    id: 'green-valley',
    name: 'Green Valley',
    code: 'GV',
    region: 'Arizona',
    isActive: true
  },
  {
    id: 'rita-ranch',
    name: 'Rita Ranch',
    code: 'RR',
    region: 'Arizona',
    isActive: true
  },
  {
    id: 'grant',
    name: 'Grant',
    code: 'GT',
    region: 'Arizona',
    isActive: true
  },
  {
    id: 'palm-desert',
    name: 'Palm Desert',
    code: 'PD',
    region: 'California',
    isActive: true
  },
  {
    id: 'palm-springs',
    name: 'Palm Springs',
    code: 'PS',
    region: 'California',
    isActive: true
  },
  {
    id: 'indio',
    name: 'Indio',
    code: 'ID',
    region: 'California',
    isActive: true
  },
  {
    id: 'carlsbad',
    name: 'Carlsbad',
    code: 'CB',
    region: 'California',
    isActive: true
  },
  {
    id: 'carmel-mountain',
    name: 'Carmel Mountain',
    code: 'CM',
    region: 'California',
    isActive: true
  },
  {
    id: 'phoenix',
    name: 'Phoenix',
    code: 'PH',
    region: 'Arizona',
    isActive: true
  },
  {
    id: 'scottsdale',
    name: 'Scottsdale',
    code: 'SD',
    region: 'Arizona',
    isActive: true
  },
  {
    id: 'tempe',
    name: 'Tempe',
    code: 'TP',
    region: 'Arizona',
    isActive: true
  },
  {
    id: 'sierra-vista',
    name: 'Sierra Vista',
    code: 'SV',
    region: 'Arizona',
    isActive: true
  },
  {
    id: 'chorost-co-store',
    name: 'Chorost & Co. Store',
    code: 'CCOS',
    region: 'Arizona',
    isActive: true
  },
  {
    id: 'processing-center',
    name: 'Processing Center',
    code: 'PC',
    region: 'Arizona',
    isActive: true
  }
];

export const getActiveStores = () => STORES.filter(store => store.isActive);

export const getStoreById = (id: string) => STORES.find(store => store.id === id);

export const getStoreByName = (name: string) => STORES.find(store => store.name === name);

export const getStoresByRegion = (region: string) => STORES.filter(store => store.region === region); 